export const DEFAULT_CURRENCY = 'AUDD';
export const MAIN_WALLET_ID = 'MAIN';
export const WITHDRAWABLE_WALLET_TYPES = ['MAIN', 'PERSONAL'];
export const KYC_APPROVED_STATUS = 'approved';
export const MFA_ACTIVE_STATUS = 'on';
export const TOTP_VERIFICATION_TYPE = 'totp';
export const MFA_TOKEN_LENGTH = 6;
export const COMMENT_MAX_LENGTH = 250;
export const ACCOUNT_NAME_MAX_LENGTH = 100;
export const COPY_FEEDBACK_DURATION_MS = 2000;
export const AUDD_CRYPTO_PRECISION = 8;
export const AUDD_FIAT_PRECISION = 2;

export const getTagLabel = (tagType: string | null | undefined): string => {
  if (!tagType) return '';
  const labels: Record<string, string> = {
    destination_tag: _t('Destination tag', 'NOVA_WALLET.DESTINATION_TAG'),
    memo_id: _t('Memo ID', 'NOVA_WALLET.MEMO_ID'),
    note: _t('Note', 'NOVA_WALLET.NOTE'),
    tag: _t('Tag', 'NOVA_WALLET.TAG'),
  };
  return labels[tagType] ?? tagType.split('_').map((w: string) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

export const NETWORK_DISPLAY_NAMES: Record<string, string> = {
  stellar: 'Stellar',
  base: 'Base',
  ethereum: 'Ethereum',
  hederanetwork: 'Hedera',
  solana: 'Solana',
  ripple: 'XRP',
  xrpl: 'XRPL',
  redbelly: 'Redbelly',
  xdc: 'XDC',
};
